import {
  ACTIVATE_TEMPLATE,
  DEACTIVATE_TEMPLATE,
  DEACTIVATE_TEMPLATES,
  HIDE_SELECTOR,
  SET_MAX_TEMPLATES,
  SHOW_SELECTOR,
  STORE_TEMPLATES
} from '../actions/types'

const templatesReducer = function (state = {
  maxTemplates: -1,
  selected: [],
  showTemplateSelector: true,
  templates: false
}, action) {
  switch (action.type) {
    case STORE_TEMPLATES:
      return {
        ...state,
        templates: action.templates
      }
    case HIDE_SELECTOR:
      return {
        ...state,
        showTemplateSelector: false
      }
    case SET_MAX_TEMPLATES:
      return {
        ...state,
        maxTemplates: action.maximum
      }
    case SHOW_SELECTOR:
      return {
        ...state,
        showTemplateSelector: true
      }
    case ACTIVATE_TEMPLATE:
      return {
        ...state,
        selected: [...state.selected.filter(id => id !== action.id), action.id]
      }
    case DEACTIVATE_TEMPLATE:
      return {
        ...state,
        selected: state.selected.filter(id => id !== action.id)
      }
    case DEACTIVATE_TEMPLATES:
      return {
        ...state,
        selected: []
      }
    default:
      return state
  }
}
export default templatesReducer



// WEBPACK FOOTER //
// /app/js/reducers/templatesReducer.js